

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-grid-load-charts',
  templateUrl: './grid-load-charts.component.html',
  styleUrls: ['./grid-load-charts.component.css']
})
export class GridLoadChartsComponent implements OnInit, OnDestroy {

  public destroyed = new Subject<any>();

  constructor() {

  }
  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
